/**
 * When listening for events on the Paysafe SDK fields,
 * event.target.fieldName returns the "field name" in PascalCase,
 * even though we instantiate it with an "id" in camelCase.
 * Here we map id by field name.
 */

export const fieldNames = {
  CVV: 'Cvv',
  CARD_NUMBER: 'CardNumber',
  EXPIRY_DATE: 'ExpiryDate',
  APPLE_PAY: 'ApplePay',
  SECURITY_CODE: 'securityCode',
  EXPIRATION: 'expiration',
};

export const idByFieldName = {
  [fieldNames.CVV]: 'cvv',
  [fieldNames.CARD_NUMBER]: 'cardNumber',
  [fieldNames.EXPIRY_DATE]: 'expiryDate',
  [fieldNames.SECURITY_CODE]: 'securityCode',
  [fieldNames.EXPIRATION]: 'expiration',
  [fieldNames.APPLE_PAY]: 'applePay',
};

export const errorMessageByFieldName = {
  [fieldNames.CVV]: 'Invalid CVV',
  [fieldNames.CARD_NUMBER]: 'Invalid Card Number',
  cardNumber: 'Invalid Card Number',
  [fieldNames.EXPIRY_DATE]: 'Invalid Expiration Date',
  [fieldNames.SECURITY_CODE]: 'Invalid CVV',
  [fieldNames.EXPIRATION]: 'Invalid Expiration Date',
};

export const inputElementByFieldName = {
  [fieldNames.CVV]: document.getElementById(idByFieldName[fieldNames.CVV]),
  [fieldNames.CARD_NUMBER]: document.getElementById(
    idByFieldName[fieldNames.CARD_NUMBER]
  ),
  [fieldNames.EXPIRY_DATE]: document.getElementById(
    idByFieldName[fieldNames.EXPIRY_DATE]
  ),
};
